<template>
    <div class="review">
        <v-alert outlined text dense color="purple"> この画面は作成中です。</v-alert>
      <h2>岡本表面加工研究所株式会社</h2>

        <!--<div>{{sup_cd}}</div>-->

        <v-radio-group class="narrow-padding" v-model="review_class" row dense single-line>
            <v-radio label="クチコミ" :value="1" />
            <v-radio label="訪問" :value="2" />
        </v-radio-group>

        <v-form ref="formEdit" v-model="valid" lazy-validation>

            <v-row dense>
                <v-col>
                    <date-input-field v-model="review_date"></date-input-field>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col>
                    <v-select
                            :items="reasons"
                            label="訪問理由"
                            item-text="reason_name"
                            item-value="reason_cd"
                            v-model="reason"
                    ></v-select>
                </v-col>
            </v-row>

            <v-textarea
                    name="input-7-1"
                    label="内容"
                    value=""
                    hint=""
                    v-model="content"
                    :counter="1000"
                    maxlength="1000"
                    :rules="validateRules.contentRules"
                    required
            ></v-textarea>

            <v-row dense class="pl-10">

                <v-col class="" cols="12" dense>
                    <v-radio-group class="pa-0 ma-0" v-model="goodOrBad" row>
                        <v-radio label="通常" value="N" />
                        <v-radio label="GoodNews" color="blue" value="G" />
                        <v-radio label="BadNews" color="red" value="B" />
                    </v-radio-group>
                </v-col>

                <v-col class="" cols="12" dense>
                    <v-radio-group class="pa-0 ma-0" v-model="importance" row>
                        <v-radio label="通常" value="0" />
                        <v-radio label="重要" color="blue" value="1" />
                        <v-radio label="最重要" color="orange" value="2" />
                        <v-radio label="緊急" color="red" value="3" />
                    </v-radio-group>
                </v-col>

            </v-row>


            <v-text-field label="応対者" placeholder="" v-model="inputPerson">
                <template v-slot:append-outer>
                    <v-btn v-on:click="onAddPersonClick">追加</v-btn>
                </template>
            </v-text-field>

            <span v-for="(tag,tagIdx) in persons" class="chip_container" :key="tagIdx">
                <v-chip close @click:close="onDeletePersonClick(tagIdx)">{{tag}}</v-chip>
            </span>

        </v-form>




        <v-container>
            <v-row>
                <div></div>
                <v-spacer></v-spacer>
                <div>
                    <v-btn class="mr-3" color="primary">投稿</v-btn>
                    <v-btn v-on:click="onCancelClick">キャンセル</v-btn>
                </div>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import ObjectParamSupport from "../../components/ObjectParamSupport";
import BaseView from "../../components/BaseView";
export default {
    mixins:[BaseView,ObjectParamSupport],
    components: {
    },
    props:{
        sup_cd:String
    },
    data: () => ({
        isInitialized:false,
        isFetched:false,
        isLoading:false,
        isDownloading:false,

        review_class:1,

        review_date:"",

        reason:"",

        content:"",
        goodOrBad:"N",
        importance:"0",

        inputPerson:"",
        persons:[],
        inputStaff:"",
        staffs:[],

        reasons:[
            { reason_cd:"1",reason_name:"一般訪問"},
            { reason_cd:"2",reason_name:"支給品持込"},
            { reason_cd:"3",reason_name:"成果物引取"},
            { reason_cd:"4",reason_name:"品質クレーム"},
        ],

        valid: true,
        validateRules:{
            contentRules: [
                v => !!v || '内容は必須項目です',
                v => (v && v.length <= 1000) || '内容は1000文字以内で入力してください'
            ],
        },

        condition:{},
        pager:{},
        errors:{},
    }),
    computed: {

    },
    mounted:function() {
        this.setupConditions();
    },
    created:function() {
    },
    watch: {
        '$route':function (to, from) {
            this.setupConditions();
        },
    },
    methods: {
        setupConditions(){
            let p = this.getObjectParam();
            if (p){
                // パラメータの転写
            }
        },

        fetchData(needDataFetch){
            let self = this;
            if (!this.isInitialized){
                this.fetchBasicData(function () {
                    self.fetchData(needDataFetch)
                });
                return;
            }
            if (needDataFetch){
                this.isLoading = true;
                Promise.resolve()
                    .then(data => {
                        //
                    })
                    .catch(function(err) {
                        console.log(err);
                        self.showErrorToast("データの取得に失敗しました。");
                    });
            }
        },

        fetchBasicData(finishProc){
            this.isInitialized = true;
            if (finishProc){
                finishProc();
            }
        },

        onAddPersonClick(){

            let tag = this.inputPerson;

            if (tag && (this.persons.indexOf(tag) === -1)){
                this.persons.push(tag);
                this.inputPerson = "";
            }
        },
        onDeletePersonClick(idx){
            this.persons.splice(idx,1);
        },

        onCancelClick(){
            //<router-link :to="'/supplier/' + sup_cd + '/review'">口コミ投稿</router-link>
            //let url = "/supplier/" + this.sup_cd;
            this.$router.push({ name: 'supplier', params: { sup_cd: this.sup_cd } })
        },
    },

}
</script>